export const buildAuthUserDisplayName = (a) => {
    const parts = [a.firstName, a.lastName].map(p => (p ?? '').trim()).filter(Boolean);
    if (parts.length > 0) {
        return parts.join(' ');
    }
    return (a.login ?? '').trim();
};
